export const FirebaseConfig = {
	"projectId": "ordex-ride",
	"appId": "1:432546579047:web:e527b89e587c8701ebcac2",
	"databaseURL": "https://ordex-ride-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "ordex-ride.firebasestorage.app",
	"apiKey": "AIzaSyBWR8tJQUV09w1x6GmcWMAo-eoGVKpcJaI",
	"authDomain": "ordex-ride.firebaseapp.com",
	"messagingSenderId": "432546579047",
	"measurementId": "G-ZVLQ9T2CR1"
};